import { Component } from '@angular/core';
import { TopNavBarComponent } from './top-nav-bar/top-nav-bar.component';
import { FooterComponent } from './footer/footer.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { SeoService } from '../services/utility/seo.service';
@Component({
  selector: 'app-website-layout',
  standalone: true,
  imports: [RouterOutlet,TopNavBarComponent, FooterComponent],
  templateUrl: './website-layout.component.html',
  styleUrl: './website-layout.component.scss'
})
export class WebsiteLayoutComponent {

  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller,
    private seoService: SeoService
  ) {}

  ngOnInit() {
  }
}
